import { QueryFunctionContext } from 'react-query';
import { baseQuery } from '../baseQuery';
import { DefaultOptionType } from 'antd/es/select';

export const getServiceServiceTypes = async ({
  queryKey,
}: QueryFunctionContext<[string, number | undefined]>): Promise<DefaultOptionType[]> => {
  const [_, id] = queryKey;
  const customerId = id ? `?customer_id=${id}` : '';

  const { data } = await baseQuery(`service-service-types${customerId}`);

  return data;
};
